import {usePaymentTerms} from 'src/settings/use-payment-terms'

export function usePaymentTermsOptions(current: string | null | undefined): string[] {
    const {data: terms = []} = usePaymentTerms()
    const value = current?.trim()
    return value && !terms.includes(value) ? [...terms, value] : terms
}
